import * as React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Colors } from "../theme/colors";
import { Masonry } from "./masonry";
import { ScrollIcon } from "../icons/scrollIcon";
import { Section } from "./section";
import { GithubIcon } from "../icons/githubIcon";
import { XINGIcon } from "../icons/xingIcon";
import { StravaIcon } from "../icons/stravaIcon";
import { MailIcon } from "../icons/mailIcon";
const GlobalStyle = createGlobalStyle `
    html, body {
        margin: 0;
    }

    html {
        scroll-behavior: smooth;
    }

    body {
        color: ${Colors.FG_1};
        background-color: ${Colors.BG_1};

        font-family: monospace;
    }
`;
const Header = styled.header.withConfig({ displayName: "Header", componentId: "sc-wt09x5" }) `
    display: flex;
    justify-content: center;
    align-items: center;

    position: relative;
    height: 100vh;
    background-image: url("me.jpg");
    background-size: cover;
`;
const H1 = styled.h1.withConfig({ displayName: "H1", componentId: "sc-x69t4t" }) `
    max-width: 550px;
    
    font-size: 2em;
    font-weight: normal;
    text-align: center;
`;
const EM = styled.em.withConfig({ displayName: "EM", componentId: "sc-19s0e7p" }) `
    color: ${Colors.ACCENT};
    font-style: inherit;
`;
const StyledScrollIcon = styled(ScrollIcon).withConfig({ displayName: "StyledScrollIcon", componentId: "sc-ytyv8h" }) `
    position: absolute;
    bottom: 2em;
`;
const GraySection = styled(Section).withConfig({ displayName: "GraySection", componentId: "sc-1a5eltj" }) `
    background: ${Colors.BG_2};
`;
const Links = styled.div.withConfig({ displayName: "Links", componentId: "sc-1ubnm1l" }) `
    display: grid;
    grid-auto-flow: column;
    grid-gap: 30px;
    justify-content: center;

    > a {
        display: flex;
        align-items: center;

        color: inherit;

        text-decoration: none;

        > svg {
            height: 1.5em;
            margin-right: 0.3em;
        }
    }
`;
export const App = () => {
    const content = window.content;
    return (React.createElement(React.Fragment, null,
        React.createElement(GlobalStyle, null),
        React.createElement(Header, { id: "home" },
            React.createElement(H1, null,
                "Hi, ich bin ",
                React.createElement(EM, null, "Daniel Kirchhof"),
                ", Web- & Softwareentwickler aus D\u00FCsseldorf."),
            React.createElement(StyledScrollIcon, null)),
        React.createElement("main", null,
            React.createElement(Section, { id: "projects" },
                React.createElement(Masonry, { items: content.projects })),
            React.createElement(GraySection, { id: "contact" },
                React.createElement(Links, null,
                    React.createElement("a", { target: "_blank", href: "mailto:dkirchhof@gmail.com" },
                        React.createElement(MailIcon, null),
                        "Mail"),
                    React.createElement("a", { target: "_blank", href: "https://github.com/dkirchhof" },
                        React.createElement(GithubIcon, null),
                        "Github"),
                    React.createElement("a", { target: "_blank", href: "https://www.xing.com/profile/Daniel_Kirchhof5" },
                        React.createElement(XINGIcon, null),
                        "XING"),
                    React.createElement("a", { target: "_blank", href: "https://www.strava.com/athletes/18257569" },
                        React.createElement(StravaIcon, null),
                        "Strava"))))));
};
